import styled from "styled-components";

import {
  greyText,
  lightGreyOutline,
  lightGreyText,
  lightGreys,
} from "../../styles";
import { EASE, popIn, reducedMotion } from "./motion";

export const DetailText = styled.p`
  margin: 0;
  font-family: "Apercu";
  font-size: 13px;
  line-height: 1.6;
  color: ${greyText};
  white-space: pre-line;
`;

export const DetailSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 0 8px;
  animation: ${popIn} 0.3s ${EASE} both;
  animation-delay: 60ms;
  ${reducedMotion}
`;

export const DetailSectionLabel = styled.span`
  font-family: "Apercu";
  font-size: 12px;
  color: ${lightGreyText};
`;

export const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 7px;
  border-radius: 999px;
  background: ${lightGreys.KPIBackground};
  box-shadow: inset 0 0 0 1px ${lightGreyOutline};
  font-family: "ApercuMono", "Apercu", monospace;
  font-size: 10.5px;
  color: ${greyText};
  white-space: nowrap;
`;
